export default "__VITE_ASSET__2708d75c__"